// @ts-nocheck

import { BasketActionTypes } from '../../../types/actions/basket';

export const basketItemSetIsMPActive = ({ oddsId, isMonopolyActive }) => ({
  type: BasketActionTypes.SET_ITEM_IS_MP_ACTIVE,
  payload: {
    oddsId,
    isMonopolyActive,
  },
});

export const basketSetIsMPActive = ({ isMonopolyActive }) => ({
  type: BasketActionTypes.SET_IS_MP_ACTIVE,
  payload: {
    isMonopolyActive,
  },
});

export const basketItemSetMPCard = ({ oddsId, familyId, index }) => ({
  type: BasketActionTypes.SET_ITEM_MP_CARD,
  payload: {
    oddsId,
    familyId,
    index,
  },
});

export const basketItemDelMPCard = ({ oddsId }) => ({
  type: BasketActionTypes.DEL_ITEM_MP_CARD,
  payload: {
    oddsId,
  },
});

export const basketSetMPCard = ({ familyId, index }) => ({
  type: BasketActionTypes.SET_MP_CARD,
  payload: {
    familyId,
    index,
  },
});

export const basketDelMPCard = () => ({
  type: BasketActionTypes.DEL_MP_CARD,
});

export const resetAllMPActives = () => ({
  type: BasketActionTypes.RESET_ALL_MP_ACTIVES,
});
